import React from 'react';
import PropTypes from 'prop-types';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler,
  LineElement,
  PointElement,
  registerables as registerablesjs,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import styled from 'styled-components';
import theme from '../../theme';

ChartJS.register(...registerablesjs);

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Filler,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const ChartContainer = styled.div``;

/*Note: The order of data.labels, data.datesets.data and datea.datesets.backgroundColor
must be in their corresponding information
Sample: https://www.chartjs.org/docs/latest/charts/doughnut.html
*/
const BarChart = ({ config, customOptions = {}, horizontal }) => {
  const defaultConfig = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: '#ffffff',
        borderWidth: 0,
      },
    ],
    ...config,
  };
  const options = {
    indexAxis: horizontal ? 'y' : 'x',
    hoverBackgroundColor: undefined,
    maxBarThickness: 22,
    responsive: true,
    plugins: {
      // updateMode: 'resize',
      // maintainAspectRatio: false,
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: theme().colors.bgBox,
        position: 'nearest',
        yAlign: 'bottom',
        borderWidth: 1,
        borderColor: theme().colors.border,
        padding: 12,
        titleColor: theme().colors.textPrimary,
        titleFont: { weight: 'bold', size: '16px' },
        bodyColor: theme().colors.textPrimary,
        displayColors: false,
      },
      title: {
        display: false,
      },
    },
  };
  return (
    <ChartContainer>
      <Chart
        type="bar"
        data={defaultConfig}
        options={{ ...options, ...customOptions }}
      />
    </ChartContainer>
  );
};

BarChart.propTypes = {
  config: PropTypes.object,
  customOptions: PropTypes.object,
  horizontal: PropTypes.bool,
};

export default BarChart;
